<template>
  <div class="mask">
    <div class="page-container-mc">
      <div class="modal-container">
        <div class="modal-header">
          <h2 class="header">Punto de venta cerrado</h2>
        </div>
        <div class="modal-body">
          <div class="msg-container">
            <img src="../../assets/imgs/cart-off.svg" class="icon" alt="carrito"/>
            <p class="mensaje-body">
            El cierre de caja no se efectúo el dia anterior, por favor realice
            un corte para continuar.
          </p>
          </div>
        </div>
        <div class="modal-footer">
          <CierreCaja
            :center="true"
            @cerrarCorte="cerrarCorte"
            :sesion="sesion"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CierreCaja from "./CierreCaja.vue";
export default {
  name: "ModalCierrePv",
  data() {
    return {};
  },
  components: {
    CierreCaja,
  },
  emits: ["cerrarCorte"],
  props: ["sesion"],
  methods: {
    cerrarCorte() {
      this.$emit("cerrarCorte", 0);
    },
  },
};
</script>

<style scoped>
/* .mask{
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    opacity: 0.46;
    background-color: rgb(33, 33, 33);
    border-color: rgb(33, 33, 33);
    z-index: 200;
} */


.mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 101;
}

.page-container-mc {
  display: flex;
  height: calc(100vh - 100px);
  width: 100%;
  align-items: center;
  justify-content: center;
}

.modal-container {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(3, minmax(min-content, 100%));
  justify-self: center;
  align-self: center;
  width: 620px;
  background-color: #fff;
  border: solid 2px rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  box-shadow: 0px 3px 6px #00000029;
}

.msg-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-header {
  height: 80px;
  grid-row: 1/2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body {
  height: 200px;
  grid-row: 2/3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header{
  color: #0A4F9C;
  font-weight: bold!important;
  font-size: 25px!important;
}

.mensaje-body{
  text-align: center;
font: normal normal normal 16px/22px Open Sans;
letter-spacing: 0px;
color: #6F6F6F;

}

.icon {
  height: 110px;
  width: 110px;
}

.modal-footer {
  height: 80px;
  grid-row: 3/4;
  display: grid;
  place-content: center;
}

@media screen and (max-width:1279px){

  .modal-container {
width: 500px;
}

.mensaje-body{
font: normal normal normal 13px/20px Open Sans;
}

.header{
  font-size: 22px!important;
}

}

@media screen and (max-width:767px){

  .modal-container {
width: 300px;
}

.mensaje-body{
font: normal normal normal 11px/20px Open Sans;
}

.header{
  font-size: 18px!important;
}

}
</style>
